var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('firma-archivo',{on:{"documento-firmado":_vm.documentoFirmado}}),_c('mail-archivo',{directives:[{name:"show",rawName:"v-show",value:(_vm.mailVisible),expression:"mailVisible"}],attrs:{"documento":_vm.idDocumento}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }